import React from "react";
//#region types
import { SearchSelectionProps } from "models/propTypes/selectionPropTypes";
//#endregion
//#region components
import DialogEvents from "../dialogs/dialogEvents";
import SelectionGroup from "./selectionGroup";
import SelectionDialog from "./selectionDialog";
//#endregion

const SearchSelection: React.FC<SearchSelectionProps> = (props) => {
  return (
    <DialogEvents
      render={(isOpen, openDialog, closeDialog) => (
        <>
          <SelectionGroup
            {...props}
            value={props.value ? [props.value] : []}
            onChange={(item) => props.onChange(item[0])}
            onViewAllClick={openDialog}
          />
          <SelectionDialog {...props} isOpen={isOpen} cancelHandler={closeDialog} />
        </>
      )}
    />
  );
};

export default SearchSelection;
